export const Alert = ( { message, type = 'alert', ...other } ) => (
	<p className={`soo-alert -${type}`} role={type} {...other}>{message}</p>
);
